<a (click)="onOpenFeed()" [routerLink]="['/']" routerLinkActive="text-red-500! font-bold" [routerLinkActiveOptions]="{exact: true}">
  <sens-icon icon="#icon-faps" [size]="28"/>
  Faps
</a>

<a [routerLink]="['/search']" routerLinkActive="text-red-500! font-bold">
  <sens-icon icon="#icon-search" [size]="28"/>
  Search
</a>

<a [routerLink]="['/documents']" routerLinkActive="text-red-500! font-bold">
  <sens-icon icon="#icon-menu" [size]="28"/>
  Docs
</a>

<a [routerLink]="['/profile']" routerLinkActive="text-red-500! font-bold" [routerLinkActiveOptions]="{exact: true}">
  @if (!!user()?.is_basic_subscribed) {
    <span class="badge">
       <sens-icon icon="#icon-crown" class="mb-0!" [size]="10"/>
    </span>
  }
  <sens-icon icon="#icon-user-circle" [size]="28"/>
  Profile
</a>
